module.exports = __webpack_public_path__ + "img/edelstahlarbeiten_250.a94fc16d.webp";